/* eslint-disable arrow-parens */
import { useState, useEffect, useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../../../constants/caption/dashboardHeader";
import { AuthContext, UIContext } from "../../../../../../../../contexts";
import ScrollTabPanel from "../../../../../../../shared/tabPanelComponent/ScrollTabPanel";
import a11yScrollableProps from "../../../../../../../../constants/tabPanelProps/ayScrollableProps";
import DependentInformationDetails from "./dependentInformationDetails/DependentInformationDetails";
import DependentBenefitDetails from "./dependentBenefitDetails/DependentBenefitDetails";
import DependentVEBBenefitDetailsGrid from "./dependentVEBBenefitDetails/DependentVEBBenefitDetails";
import ClaimDetails from "../../../claimDetails/ClaimDetailsGrid";
import NoteDetails from "../../../noteDetails/NoteDetails";
import DependentHistoryDetails from "./dependentHistoryDetails/DependentHistoryDetails";

import { Box, Tab, Tabs, Button, Badge, withStyles } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import ReplyIcon from "@material-ui/icons/Reply";
import WcIcon from "@material-ui/icons/Wc";
import useRouteParam from "../../../../../../../../hooks/useRouteParam";
import encryption from "../../../../../../../../utils/commonFunctions/encryption";

import "../../../../members.css";
import ExtractRouteParams from "../../../../../../../../utils/commonFunctions/extractRouteParams";
import initCapitalize from "../../../../../../../../utils/commonFunctions/initCapitalize";
import { api } from "../../../../../../../../utils/api";
import { trackPromise } from "react-promise-tracker";
import {
	HistoryContactInformation,
	HistoryProfileInformation,
	Member
} from "../../../../../../../../@types/member.types";
import DependentVEBBenefitDetails from "./dependentVEBBenefitDetails/DependentVEBBenefitDetails";
import DependentClaimDetailsGrid from "./dependentClaimDetails/DependentClaimDetailsgGrid";
import ClaimList from "../../../claim/claimList/ClaimList";
import { MEMBER_PORTAL_REDIRECTION } from "../../../../../../../../config/config";
import { GROUP_NUMBER } from "../../../../../../../../constants/groups";
import DependentSettings from "./dependentSettings/DependentSettings";
import DependentLogs from "./dependentLogs/DependentLogs";
import { userInfo } from "os";
import { TabIndex } from "../../../../../../../../constants/tabPanelProps/tabIndex";
import ROLES from "../../../../../../../../constants/roles";
import { useEnroller } from "../../../../../../../../hooks";
import isEmployerRoute from "../../../../../../../../utils/commonFunctions/isEmployerRoute";
import { getPermissionsFromGroupOwner } from "../../../../../../../../utils/getPermissionsFromGroupOwner";
import CircularLoader from "../../../../../../../shared/loader/CircularLoader";

const StyledBadge = withStyles((theme) => ({
	badge: {
		backgroundColor: "#b8ddc0",
		color: "#558b2f",
		fontWeight: "bold",
		// boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
		top: 3,
		left: -15,
		"&::after": {
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			borderRadius: "50%",
			// animation: "$ripple 1.2s infinite ease-in-out",
			// border: "1px solid currentColor",
			// eslint-disable-next-line quotes
			content: '""'
		}
	},
	"@keyframes ripple": {
		"0%": {
			transform: "scale(.8)",
			opacity: 1
		},
		"100%": {
			transform: "scale(2.4)",
			opacity: 0
		}
	}
}))(Badge);

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1
	}
}));

const DependentDetails = (): JSX.Element => {
	const classes = useStyles();
	const { setMemberUI } = useContext(UIContext);
	const { setDashboardHeader } = useContext(UIContext);
	const [tabValue, setTabValue] = useState(0);
	const [benefitDetails, setBenefitDetails] = useState([]);
	const { user } = useContext(AuthContext);
	const { isEnroller } = useEnroller();
	const [dependentClaimDetails, setDependentClaimDetails] = useState([]);
	const [dependentVEBBenefitDetails, setDependentVEBBenefitDetails] = useState([]);
	const querySSN = useRouteParam("qs");
	const queryEmployeeSSN = useRouteParam("qe");
	// console.log("Checking the querySSN thing --->", querySSN, queryEmployeeSSN);
	const queryGroupNumber = useRouteParam("gn");
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)
	const navigate = useNavigate();
	const [employee, setEmployee] = useState<Member>();
	const [dependent, setDependent] = useState<Member>();
	const [historyDependentProfileInformation, setHistoryDependentProfileInformation] = useState<
		HistoryProfileInformation[]
	>([]);
	const [historyDependentContactInformation, setHistoryDependentContactInformation] = useState<
		HistoryContactInformation[]
	>([]);
	const [countNotes, setCountNotes] = useState<number | null>(null);
	const [dependentBySSNWithEmployeeLoader, setDependentBySSNWithEmployeeLoader] = useState(true);
	const [countNotesForEachMemberLoader, setCountNotesForEachMemberLoader] = useState(true);

	// console.log("dependent===>", dependent);

	const [tabsAndPanels, setTabsAndPanels] = useState<any[]>([]);

	const dependentDetailsTabPermission =
		user && isEmployerRoute() && queryGroupNumber
			? getPermissionsFromGroupOwner(user, Number(queryGroupNumber))?.employer_members_menu.self
					.members_list_table.member_details_view
			: user
			? getPermissionsFromGroupOwner(user, 0)?.members_menu.self.members_list_table.member_details_view
			: null;

	const getCountNotesForEachMember = useCallback(async (group_number: number, SSN: string) => {
		setCountNotesForEachMemberLoader(true);
		try {
			const findNotesQuery = {
				group_number,
				SSN
			};

			const response: number = await api.notes.getCountNotesForEachMember(findNotesQuery);

			if (response) {
				setCountNotes(response);
			}
		} catch (error) {
			console.log("Error fetching CountNotesForEachMember", error);
		} finally {
			setCountNotesForEachMemberLoader(false);
		}
	}, []);

	const getDependentBySSNWithEmployee = useCallback(
		async (SSN: string, group_number: number, queryEmployeeSSN: string) => {
			// if (!queryEmployeeSSN) {
			// 	console.error("Error: employee SSN is not available.");
			// 	return;
			// }
			setDependentBySSNWithEmployeeLoader(true);
			try {
				const findDependentWithEmployeeQuery = {
					group_number,
					SSN,
					employee_ssn: queryEmployeeSSN
				};
				// console.log("Checkingforthedependentthing---->", findDependentWithEmployeeQuery);
				const response = await api.member.getDependentBySSNWithEmployee(findDependentWithEmployeeQuery);
				if (response) {
					const {
						employeeInstance,
						dependentInstance,
						historyDependentProfileInformation,
						historyDependentContactInformation
					} = response;
					if (employeeInstance) {
						setEmployee(Object.assign({}, employeeInstance));
					}
					if (dependentInstance) {
						setDependent(Object.assign({}, dependentInstance));
						setMemberUI(
							Object.assign(
								{},
								{
									firstName: dependentInstance?.first_name,
									lastName: dependentInstance?.last_name,
									role: dependentInstance?.role as "EMPLOYEE" | "DEPENDENT",
									employeeId: null
								}
							)
						);
					}
					if (historyDependentProfileInformation) {
						setHistoryDependentProfileInformation(Object.assign([], historyDependentProfileInformation));
					}
					if (historyDependentContactInformation) {
						setHistoryDependentContactInformation(Object.assign([], historyDependentContactInformation));
					}
				}
			} catch (error) {
				console.log("Error fetching DependentBySSNWithEmployee", error);
			} finally {
				setDependentBySSNWithEmployeeLoader(false);
			}
		},
		[setMemberUI, queryEmployeeSSN] // Add queryEmployeeSSN here
	);

	const handleLabelChange = (event: any, value: number) => {
		// const clickedTabName: string = event.target.innerText;
		// console.log("eventing", event);
		// console.log("========handleLabelChange============>", clickedTabName, TabIndex[clickedTabName]);
		setTabValue(value);
	};

	const getDependentClaimDetails = useCallback(() => {
		const _dependentClaimDetails = [
			{
				claim_number: "2022-150-000026-000",
				paitent_name: "",
				date_of_service: "03-10-22",
				type: "Dental/Professional/Institution",
				provider_name: "North Houston Family Medicine",
				status: "Paid",
				paid_date: "04-10-22",
				charges: "$418.00",
				paid_by_plan: "$315.71"
			}
		];
		setDependentClaimDetails(Object.assign([], _dependentClaimDetails));
	}, []);

	// const getDependentVEBBenefitDetails = useCallback(() => {
	// 	setDependentVEBBenefitDetails(
	// 		Object.assign(
	// 			[],
	// 			[
	// 				{
	// 					plan_name: "Christmas Club Election Form",
	// 					enrollment_date: "18/11/2022",
	// 					effective_date: "04/01/2023",
	// 					// status: "Active",
	// 					// start_date: "05/01/2022",
	// 					benefit_end_date: "Current",
	// 					total_premium: "$25.00",
	// 					covered_dependents: [
	// 						{
	// 							first_name: "Dona",
	// 							last_name: "Roy",
	// 							relationship: "Spouse"
	// 						},
	// 						{
	// 							first_name: "Akansha",
	// 							last_name: "Prasad",
	// 							relationship: "Daughter"
	// 						}
	// 					]
	// 				}
	// 			]
	// 		)
	// 	);
	// }, []);

	const handleOpenDepdentPortalClick = useCallback(() => {
		if (dependent === undefined) {
			return;
		}
		const token = localStorage.getItem("@jwt");
		const queryParams = `token=${token}&id=${dependent._id}`;
		const url = `${MEMBER_PORTAL_REDIRECTION}/verify`;
		const redirectionUrl = `${url}?${queryParams}`;
		const target = "_blank";
		window.open(redirectionUrl);
	}, [dependent]);

	const handleNavigateReturnToEmployee = useCallback(async () => {
		// console.log("dependent?.employee_SSN", dependent?.employee_SSN);
		const pathname = `/employer/member?gn=${queryGroupNumber}&&qs=${encryption(dependent?.employee_SSN as string)}`;
		navigate(pathname);
	}, [dependent?.employee_SSN, navigate, queryGroupNumber]);

	// const getBenefitDetails = useCallback(() => {
	// 	const _benefitDetails = [
	// 		{
	// 			plan_name: "Christmas Club Election Form",
	// 			plan_code: "CCEF-ALL",
	// 			enrollment_date: "04/07/2021",
	// 			status: "Active",
	// 			effective_date: "05/01/2022",
	// 			benefit_end_date: "Current",
	// 			plan_approved_by: "Anupam Biswas"
	// 		}
	// 	];
	// 	setBenefitDetails(Object.assign([], _benefitDetails));
	// }, []);

	useEffect(() => {
		if (querySSN && queryGroupNumber) {
			getDependentBySSNWithEmployee(querySSN as string, queryGroupNumber as number, queryEmployeeSSN as string);
			getCountNotesForEachMember(queryGroupNumber as number, querySSN as string);
		}
	}, [getDependentBySSNWithEmployee, querySSN, queryGroupNumber, getCountNotesForEachMember]);

	// useEffect(() => {
	// 	getBenefitDetails();
	// }, [getBenefitDetails]);

	// useEffect(() => {
	// 	getDependentVEBBenefitDetails();
	// }, [getDependentVEBBenefitDetails]);

	useEffect(() => {
		getDependentClaimDetails();
	}, [getDependentClaimDetails]);

	useEffect(() => {
		if (!dependent || !employee || !dependentDetailsTabPermission) return;

		const generatedTabs: any[] = [];

		if (dependentDetailsTabPermission.member_and_family_tab.view) {
			generatedTabs.push({
				label: "Dependent",
				component: <DependentInformationDetails employee={employee} dependent={dependent} />
			});
		}

		if (dependentDetailsTabPermission.core_benefits_tab.view) {
			generatedTabs.push({
				label: "Core Benefits",
				component: <DependentBenefitDetails dependent={dependent} />
			});
		}

		if (dependentDetailsTabPermission.veb_benefits_tab.view) {
			generatedTabs.push({
				label: "VEB Benefits",
				component: <DependentVEBBenefitDetails dependent={dependent} />
			});
		}

		if (dependentDetailsTabPermission.claims_tab.view) {
			generatedTabs.push({
				label: "Claims",
				component: <ClaimList member={dependent} />
			});
		}

		if (dependentDetailsTabPermission.notes_tab.view) {
			generatedTabs.push({
				label: countNotes ? (
					<StyledBadge
						anchorOrigin={{ vertical: "top", horizontal: "left" }}
						badgeContent={countNotes ? countNotes : ""}
					>
						Notes
					</StyledBadge>
				) : (
					"Notes"
				),
				component: <NoteDetails member={dependent} setCountNotes={setCountNotes} />
			});
		}

		if (dependentDetailsTabPermission.history_tab.view) {
			generatedTabs.push({
				label: "History",
				component: (
					<DependentHistoryDetails
						historyDependentProfileInformation={historyDependentProfileInformation}
						historyDependentContactInformation={historyDependentContactInformation}
						dependent={dependent}
					/>
				)
			});
		}

		if (dependentDetailsTabPermission.member_settings_tab.view) {
			generatedTabs.push({
				label: "Dependent Settings",
				component: <DependentSettings member={dependent} />
			});
		}

		if (dependentDetailsTabPermission.member_logs_tab.view) {
			generatedTabs.push({
				label: "Dependent Logs",
				component: <DependentLogs />
			});
		}

		setTabsAndPanels(generatedTabs);
	}, [
		dependentDetailsTabPermission,
		dependent,
		employee,
		countNotes,
		historyDependentProfileInformation,
		historyDependentContactInformation
	]);

	// console.log("History Dependent Profile", historyDependentProfileInformation);
	// console.log("History Dependent Contact", historyDependentContactInformation);

	return (
		<>
			{(countNotesForEachMemberLoader || dependentBySSNWithEmployeeLoader) && (
				<div
					style={{
						position: "fixed",
						inset: 0,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						zIndex: 9999,
						backgroundColor: "rgba(255, 255, 255, 0.5)"
					}}
				>
					<CircularLoader />
				</div>
			)}
			<div className="dependent-details-container" id="dependent-details-container">
				<div className="dependent-details-tab-panel-container" style={{ width: "auto" }}>
					<div className={classes.root + " glb-tab-panel-container"}>
						{/*  */}

						<Box sx={{ width: "100%" }}>
							<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
								<Tabs
									value={tabValue}
									onChange={handleLabelChange}
									variant="scrollable"
									scrollButtons="auto"
									className="glb-tab-panel"
								>
									{tabsAndPanels.map((tab, index) => (
										<Tab
											key={index}
											label={tab.label}
											value={index}
											className="glb-tab-label"
											{...a11yScrollableProps(index)}
										/>
									))}
								</Tabs>
								<div className="pf-action-button-container return-btn" id="pf-action-button-container">
									<Button
										className="button-green"
										onClick={handleOpenDepdentPortalClick}
										variant="contained"
									>
										<span className="button-label-with-icon">Open Dependent Portal</span>
										<span>
											<WcIcon className="button-icon" />
										</span>
									</Button>
									<Button
										className="button-black"
										onClick={handleNavigateReturnToEmployee}
										variant="contained"
									>
										<span className="button-label-with-icon">Return to Employee</span>
										<span>
											<ReplyIcon className="button-icon" />
										</span>
									</Button>
								</div>
								{tabsAndPanels.map((tab, index) => (
									<ScrollTabPanel key={index} value={tabValue} index={index}>
										{tab.component}
									</ScrollTabPanel>
								))}
							</Box>
						</Box>
					</div>
				</div>
			</div>
		</>
	);
};

export default DependentDetails;
